import { useTranslation } from "react-i18next";

import { AddBillingPeriod } from "../../components/AddBillingPeriod";
import { PageContainer } from "../../components/PageContainer";
import { MayorModulesType } from "../../types/mayorModules";
import { BillingsHeader } from "./BillingsHeader";
import { BillingsTable } from "./BillingsTable";

import styles from "./BillingsPage.module.scss";

export const BillingsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContainer
      headerText={t("billingsPage.title")}
      module={MayorModulesType.BillingModule}
      HeaderComponent={BillingsHeader}
    >
      <div className={styles.content}>
        <div className={styles.contentHeader}>
          <h4 className={styles.contentHeaderTitle}>{t("billingsPage.billingPeriod")}</h4>
          <AddBillingPeriod />
        </div>
        <BillingsTable />
      </div>
    </PageContainer>
  );
};
